import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const VehiclesLazy = React.lazy(
	() => import(/* webpackChunkName : 'Vehicles' */ './components/Vehicles')
);

export default (store) => {
	return {
		path: 'vehicles',
		element: <AsyncLoading component={<VehiclesLazy />} />,
	};
};
